"use strict";
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var owa_mail_search_store_1 = require("owa-mail-search-store");
var owa_session_store_1 = require("owa-session-store");
var owa_automated_message_1 = require("owa-automated-message");
exports.default = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    var sendAutomatedMessage, messageDetails, timeFormat;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, owa_automated_message_1.lazySendAutomatedMessage.import()];
            case 1:
                sendAutomatedMessage = _a.sent();
                messageDetails = {
                    subject: 'OWA 3S Query Feedback',
                    message: buildMessage(),
                    to: ['owa3squeryfeedback@service.microsoft.com'],
                    attachments: null,
                };
                timeFormat = owa_session_store_1.getUserConfiguration().UserOptions.TimeFormat;
                sendAutomatedMessage(messageDetails, timeFormat);
                return [2 /*return*/];
        }
    });
}); };
var buildMessage = function () {
    var feedbackCategories = owa_mail_search_store_1.searchStore.searchInContextFeedbackViewState.feedbackCategories
        .map(convertFeedbackCategoryToChecklistItem)
        .join('\n');
    var searchInstrumentation = convertAllInstrumentationToTable(owa_mail_search_store_1.searchStore.searchRequestInstrumentation.reverse());
    var message = "<h2>Categories</h2>" + feedbackCategories + " \n\n\n <h2>Verbatim</h2>" + owa_mail_search_store_1.searchStore.searchInContextFeedbackViewState.feedbackComments + " \n\n\n <h2>Search History</h2>" + searchInstrumentation.replace(/\n/g, '');
    return message.replace(/\n/g, '<br />');
};
var convertFeedbackCategoryToChecklistItem = function (c) {
    return (c.checked ? String.fromCharCode(9745) : String.fromCharCode(9744)) + "&nbsp;" + c.label;
};
var convertAllInstrumentationToTable = function (instrumentation) {
    return instrumentation == null || instrumentation.length == 0
        ? null
        : "<table border=\"1\">\n            " + extractInstrumentationTableHeaders(instrumentation) + "\n            " + convertInstrumentationToTableRows(instrumentation) + "\n        </table>";
};
var extractInstrumentationTableHeaders = function (instrumentation) {
    return "<thead><tr>\n        " + Object.keys(instrumentation[0])
        .map(function (key) { return "<th>" + key + "</th>"; })
        .join('') + "\n    </tr></thead>";
};
var convertInstrumentationToTableRows = function (instrumentation) {
    return instrumentation
        .map(function (e) {
        return "<tr>\n                    " + Object.keys(e)
            .map(function (key) { return convertInstrumentationFieldToTableCell(e[key]); })
            .join('') + "\n                </tr>";
    })
        .join('');
};
var convertInstrumentationFieldToTableCell = function (field) {
    if (!field) {
        return '<td></td>';
    }
    else if (field instanceof Array) {
        return "<td>" + field.join(',') + "</td>";
    }
    else if (field instanceof Date) {
        return "<td>" + field.toISOString() + "</td>";
    }
    else {
        return "<td>" + field.toString() + "</td>";
    }
};
//# sourceMappingURL=sendSearchFeedback.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/view/owa-mail-search-view/lib/utils/sendSearchFeedback.js
// module id = 4842
// module chunks = 37